import axiosConn from '../../axiosConn';
import { buildFeedbackRewardAuthConfig } from './hitLabRadioFeedbackRewardPassApi';

export const VOICE_DROP_MIN_SECONDS = 10;
export const VOICE_DROP_MAX_SECONDS = 20;
export const VOICE_DROP_UPLOAD_PREFIX = 'JGRadio/VoiceDrops';

export const normalizeVoiceDropPayload = (response) => {
  const data = response?.data?.data || response?.data || {};
  return {
    voiceDrop: data.voiceDrop || null,
    feedbackRewardPass: data.feedbackRewardPass || null,
    summary: data.summary || {},
    rows: Array.isArray(data.rows) ? data.rows : [],
    catalogItem: data.catalogItem || null,
  };
};

export const getMyVoiceDrop = ({ player } = {}) =>
  axiosConn.get(
    'hitlab/radio/listener-feedback-rewards/voice-drops/me',
    buildFeedbackRewardAuthConfig(player),
  );

export const submitVoiceDrop = ({ player, voiceDrop } = {}) =>
  axiosConn.post(
    'hitlab/radio/listener-feedback-rewards/voice-drops',
    voiceDrop,
    buildFeedbackRewardAuthConfig(player),
  );

export const listAdminVoiceDrops = ({ authConfig } = {}) =>
  axiosConn.get('hitlab/admin/radio/listener-voice-drops', authConfig);

export const approveAdminVoiceDrop = ({
  authConfig,
  id,
  reviewNote,
  approvedTitle,
} = {}) =>
  axiosConn.post(
    `hitlab/admin/radio/listener-voice-drops/${id}/approve`,
    { reviewNote, approvedTitle },
    authConfig,
  );

export const rejectAdminVoiceDrop = ({ authConfig, id, reason } = {}) =>
  axiosConn.post(
    `hitlab/admin/radio/listener-voice-drops/${id}/reject`,
    { reason },
    authConfig,
  );
